<template>
  <span>
    <i class="el-icon-edit" @click="centerDialogVisible = true" />
    <el-dialog
      :title="label"
      :visible.sync="centerDialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      custom-class="planDate"
      top="30vh"
    >
      <slot />
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="centerDialogVisible = false">取 消</el-button>
        <el-button size="mini" type="success" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
export default {
  name: 'LaunchTime',
  props: {
    label: String
  },
  data() {
    return {
      centerDialogVisible: false
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="less">
</style>
